function findIndicesInMatrix(matrix, func) {
	let j = -1;
	return {
		i: matrix.findIndex((row) => {
			j = row.findIndex(func);
			return j !== -1;
		}),
		j
	};
}
export { findIndicesInMatrix };

//# sourceMappingURL=index90.js.map